import React from "react";
import "./TermsContent.css";

const sections = [
  {
    title: "1. Introduction",
    paragraphs: [
      "These Terms and Conditions govern access to and use of the IRQGYP website and its services. By accessing this website, you agree to comply with these terms. If you do not agree, please discontinue use of the website.",
    ],
  },
  {
    title: "2. Use of the Website",
    paragraphs: [
      "This website may be used only for lawful purposes. Users agree not to:",
    ],
    bullets: [
      "Violate applicable laws or regulations;",
      "Interfere with the operation or security of the website;",
      "Attempt unauthorized access to systems or data;",
      "Use the website in any manner that may harm IRQGYP or other users.",
    ],
    after:
      "IRQGYP reserves the right to restrict or terminate access in cases of misuse.",
  },
  {
    title: "3. Information and Content",
    paragraphs: [
      "All information provided is for general informational purposes only. While efforts are made to ensure accuracy and relevance, IRQGYP does not guarantee that all content is complete, accurate, or current.",
      "Content may be updated, modified, or removed at any time without prior notice.",
    ],
  },
  {
    title: "4. Intellectual Property",
    paragraphs: [
      "All content on this website, including text, graphics, logos, images, videos, design elements, and layout, is the property of IRQGYP or used under appropriate authorization and protected by applicable intellectual property laws.",
      "No material may be copied, reproduced, distributed, or used without prior written permission.",
    ],
  },
  {
    title: "5. External Links",
    paragraphs: [
      "This website may contain links to external websites for convenience. IRQGYP is not responsible for the content, availability, or practices of third-party websites.",
      "Access to external websites is undertaken at the user's own responsibility.",
    ],
  },
  {
    title: "6. Limitation of Liability",
    paragraphs: [
      "IRQGYP shall not be liable for any damages resulting from the use of, or inability to use, this website, including technical interruptions, inaccuracies, or unauthorized access to information.",
      "Use of the website is at the user's own risk.",
    ],
  },
  {
    title: "7. Privacy",
    paragraphs: [
      "Use of this website is subject to the Privacy Policy, which explains how personal information may be collected and processed.",
    ],
  },
  {
    title: "8. User Submissions",
    paragraphs: [
      "Any information submitted through contact forms or other communication channels must be accurate and lawful. IRQGYP reserves the right to remove or disregard submissions that are inappropriate or misleading.",
    ],
  },
  {
    title: "9. Availability",
    paragraphs: [
      "Continuous access to the website cannot be guaranteed. Temporary interruptions may occur due to maintenance, updates, or technical reasons.",
    ],
  },
  {
    title: "10. Changes to Terms",
    paragraphs: [
      "IRQGYP may update these Terms and Conditions at any time. Continued use of the website after updates constitutes acceptance of the revised terms.",
    ],
  },
  {
    title: "11. Governing Law",
    paragraphs: [
      "These Terms and Conditions are governed by the laws of the Republic of Iraq. Any disputes shall be subject to the jurisdiction of the competent courts of Iraq.",
    ],
  },
  {
    title: "12. Contact",
    paragraphs: [
      "IRQGYP",
      "Villa 70, English Village, Erbil, Iraq",
      "+964 0750 202 0066",
      "info@irqgyp.com",
    ],
  },
];

const TermsContent = () => {
  return (
    <section className="termsContent">
      <div className="termsContent-inner">
        {sections.map((section) => (
          <section className="termsContent-section" key={section.title}>
            <h2>{section.title}</h2>
            {section.title === "12. Contact" ? (
              <ul className="termsContent-contactList">
                {section.paragraphs.map((paragraph) => (
                  <li key={paragraph}>{paragraph}</li>
                ))}
              </ul>
            ) : (
              section.paragraphs.map((paragraph) => (
                <p key={paragraph}>{paragraph}</p>
              ))
            )}
            {section.bullets && (
              <ul>
                {section.bullets.map((bullet) => (
                  <li key={bullet}>{bullet}</li>
                ))}
              </ul>
            )}
            {section.after && <p>{section.after}</p>}
          </section>
        ))}
      </div>
    </section>
  );
};

export default TermsContent;
